// extracted by mini-css-extract-plugin
export var addressFields = "_mw-0";
export var animationContainer = "_mw-1";
export var footer = "_mw-2";
export var lineItems = "_mw-3";
export var modalContent = "_mw-4";
export var orderName = "_mw-5";
export var strong = "_mw-6";
export var warning = "_mw-7";